















































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { ResponsiveSizes, ComponentModel } from '@/models';

@Component
export default class LayoutCss extends Vue {
  @Prop()
  size!: ResponsiveSizes;

  @Prop()
  model!: ComponentModel;

  get layoutCss() {
    if (!this.model) return null;
    return this.model.getCss('layout', this.size);
  }
}
